"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var urljoin = require("url-join");
/**
 * executes a requests, defined by APITarget
 */
var APIClient = (function () {
    function APIClient(options) {
        this.options = options;
        this.options.stubResponse = options.stubResponse || false;
        this.options.stubResponseTime = options.stubResponseTime || 200;
        this.options.throwOnErrorStatusCodes = options.throwOnErrorStatusCodes || true;
    }
    /**
     * executes a request for the given target,
     * transforms target definition to fetch parameters
     * throws `APIClientError` if `throwOnErrorStatusCodes` is true and status code of response is < 200 || > 399
     * @param target request target
     */
    APIClient.prototype.request = function (target) {
        var _this = this;
        var headers = target.headers;
        if (!headers) {
            headers = {};
        }
        if (this.options.injectHeaders) {
            headers = this.options.injectHeaders(target, headers);
        }
        var query = queryString.stringify(target.queryParameters);
        var requestUrl = urljoin(this.options.baseUrl, target.url);
        if (query) {
            requestUrl = urljoin(requestUrl, "?" + query);
        }
        var options = {
            method: target.method || "GET",
            body: JSON.stringify(target.body),
            headers: headers
        };
        return fetch(requestUrl, options)
            .then(function (response) {
            if (_this.options.throwOnErrorStatusCodes) {
                if (response.status >= 200 && response.status < 400) {
                    return response;
                }
                throw new APIClientStatusCodeError(response, response.status);
            }
            else {
                return response;
            }
        });
    };
    /**
     * executes a request for the given target and transforms the result to JSON
     * throws `APIClientError` if `throwOnErrorStatusCodes` is true and status code of response is < 200 || > 399
     * @param target
     */
    APIClient.prototype.requestJSON = function (target) {
        var _this = this;
        if (this.options.stubResponse) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    if (target.mockResponseJSON) {
                        resolve(target.mockResponseJSON());
                    }
                    else {
                        reject(new Error("No Mockdata provided"));
                    }
                }, _this.options.stubResponseTime);
            });
        }
        else {
            return this.request(target).then(function (response) {
                return response.json();
            }).catch(function (e) {
                // transform error response into json
                if (e instanceof APIClientStatusCodeError) {
                    return e.response.json().then(function (json) {
                        throw new APIClientStatusCodeError(json, e.statusCode);
                    });
                }
                throw e; // rethrow unknown error
            });
        }
    };
    /**
     * executes a request for the given target and asks target to transform JSON result into type
     * throws `APIClientError` if `throwOnErrorStatusCodes` is true and status code of response is < 200 || > 399
     * @param target
     */
    APIClient.prototype.requestType = function (target) {
        return this.requestJSON(target)
            .then(function (json) {
            return target.parse(json);
        });
    };
    return APIClient;
}());
exports.APIClient = APIClient;
function createAPIClient(options) {
    return new APIClient(options);
}
exports.createAPIClient = createAPIClient;
/**
 * represents a error caused by invaid statuscode
 */
var APIClientStatusCodeError = (function () {
    function APIClientStatusCodeError(response, statusCode) {
        this.statusCode = statusCode;
        this.response = response;
    }
    return APIClientStatusCodeError;
}());
exports.APIClientStatusCodeError = APIClientStatusCodeError;
//# sourceMappingURL=APIClient.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/network-stapler/build/APIClient.js
// module id = 689
// module chunks = 1